const ON_CHANGE_DEBOUNCE_TIMER = 300;

const ON_INPUT_DEBOUNCE_TIMER = 1000;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  // SD-LINESサービスの埋め込む
  productViewed: 'custom_product_viewed',
  addToCart: 'custom_add_to_cart',
  loggedIn: 'custom_logged_in',
};
